import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.2/js/sparta-store-utility";
import jQuery from "utilities/vendor/jquery/3.7.1/js/jquery";
import $ from "utilities/vendor/jquery/3.7.1/js/jquery";
import spartaEventsUtility from "utilities/global/sparta-events-utility/2.4.2/js/sparta-events-utility";
import currentWidgetDetails from "utilities/platform/widget-details";
















const utilityNamespace = 'fingerprintUtility';






const EVENTS = {};
class FingerprintUtility {
  constructor() {}

  _browserfingerprint(ccPath){
    window.boa =  window.boa || {};
    window.boa.fingerprint =  window.boa.fingerprint || {};

    let ns = window.boa.fingerprint;

    ns.config = {
      collector : {
        src : ccPath || "/login/sign-in/cc.go",
        async : true,
        flags : window.flagsToCollect || 155687923  
      },



      submitBtnSelector : window.__submitBtnSelector || 'a.btn-bofa-blue[name=enter-online-id-submit]'
    };

    ns.init = function(){



      window._cc = window._cc || [];
      _cc.push(['bfdc', [3,100,15]]);

      _cc.push(['ci', {
        'sid': '0602497b-ac9e-40d3-88f0-6501ae64e714',
        'tid': '5678'
        }]);
      _cc.push(['cf', ns.config.collector.flags ]); 
      _cc.push(['run', ('https:' == document.location.protocol ? 'https://'
      : 'http://') + "www.bankofamerica.com"]);

      $('<script/>').attr(
        ns.config.collector
      ).appendTo('head');
    };






    ns.prepareIAData = function ( callback ){
      if ( window._cc && window.boa && window.boa.fingerprint && boa.fingerprint.config){
        _cc.push(['cfp', function(payload) {
          if (callback){
            callback(payload);
          }
        }]
        );
      }else{
        if (callback) {
          callback();
        }
      }
    };

    ns.init();
  }

}






let fingerprintUtility = new FingerprintUtility();


export default fingerprintUtility;
